<template>
  <!-- 不需要引入login_style类样式 -->
  <div id="bigScreen" class="bigScreen" :style="{'height':screenHeight.height,'background-image':'url(\''+bgImg+'\')'}">
    <!--头部-->
    <div class="header" style="overflow:hidden;">
      <div style="width: 33%;height: 100%;float: left;"></div>
      <div class="logo">
          <div class="logo-img">
            <img :src="logo" alt />
          </div>
          <p class="title-font">{{title}}</p>
      </div>
      <div style="width: 33%;height: 100%;float: left;"></div>
      <div class="showTime" ></div>
      <div v-if="!fullscreen">
        <el-tooltip slot="label" class="item" effect="light" placement="right">
          <div slot="content">
              排队量：该技能组当前实时排队数量。<br/>
              座席空闲量：该技能组当前实时空闲座席数量。<br/>
              人工服务请求：当天进该技能组的客户数量。<br/>
              接起量：当天进该技能组座席接通服务的数量。<br/>
              接通率：接起量/人工服务请求。<br/>
              转满意度调查率：统计当天该技能组数据，转满意度调查量/客户与座席接通数量。<br/>
              好评率：统计当天该技能组数据，(非常满意+满意)/转满意度调查量。
          </div>
          <img src="../../assets/image/homeAsk.png" style="width: 18px;height: 18px;float:left;margin-left:3em;margin-top:-0.3rem;"/>
        </el-tooltip>

        <img v-if="!fullscreen" src="../../assets/image/fullScreen.png" @click="btnFull()"
          style="width: 3vmin;height: 3vmin;float:right;margin-right:3vmin;margin-top:-0.4rem;" />
        <img v-if="false" :src="setButton" @click="setScreen(1)"
          style="width: 3vmin;height: 3vmin;float:right;margin-right:7vmin;margin-top:-0.4rem;" />
        <div style="clear:both;"></div>
      </div>
    </div>
    <!--页面主体部分-->
    <section class="mainbox" >
      <!-- 上方 -->
      <div style="width: 100%;height: 50%;">
        <Row :gutter="16" style="height:100%;">
          <Col v-for="(item,index) in viewLayout.itemTop" :key="index" :span="item.span" style="height:100%;">
          <div :class="item.activeClass" style="height:100%;" class="border-type">
            <div :class="item.activeClass+'_title'"  style="height:10%"> </div>
           <!-- 通话趋势 -->
            <callTrendVue v-if="item.echartType === 'callTrend'" :pageCode="pageCode"  style="height:90%;"></callTrendVue>
            <!-- 话务分析 -->
            <trafficAnalysisVue v-if="item.echartType === 'trafficAnalysis'"  style="height:90%;"></trafficAnalysisVue>
            <!-- 座席状态 -->
            <agentStatusVue v-if="item.echartType === 'agentStatus'" style="height:90%;"></agentStatusVue>
            <!-- 技能组统计 -->
            <skillGroupVue v-if="item.echartType === 'skillGroup'" style="height:90%;"></skillGroupVue>
            <!-- 满意度评价 -->
            <satisfactionVue v-if="item.echartType === 'satisfaction'" style="height:90%;"></satisfactionVue>
          </div>
          </Col>
        </Row>
      </div>
      <div style="width: 100%;height: 50%;margin-top:0.5%">
        <Row :gutter="16" style="height:100%;">
          <Col v-for="(item,index) in viewLayout.itemBottom" :key="index" :span="item.span" style="height:100%;">
          <div :class="item.activeClass" style="height:100%;" class="border-type">
            <div :class="item.activeClass+'_title'" style="height:10%"> </div>
           <!-- 通话趋势 -->
            <callTrendVue v-if="item.echartType === 'callTrend'" :pageCode="pageCode" style="height:90%;"></callTrendVue>
            <!-- 话务分析 -->
            <trafficAnalysisVue v-if="item.echartType === 'trafficAnalysis'" style="height:90%;"></trafficAnalysisVue>
            <!-- 座席状态 -->
            <agentStatusVue v-if="item.echartType === 'agentStatus'" style="height:90%;"></agentStatusVue>
            <!-- 技能组统计 -->
            <skillGroupVue v-if="item.echartType === 'skillGroup'" style="height:90%;"></skillGroupVue>
            <!-- 满意度评价 -->
            <satisfactionVue v-if="item.echartType === 'satisfaction'" style="height:90%;"></satisfactionVue>
          </div>
          </Col>
        </Row>
      </div>
    </section>
    <BigScreenOnePop :showBigScreenOne="showBigScreenOne" @closeBigScreenOne="closeBigScreenOne"></BigScreenOnePop>
  </div>
</template>

<script>
  import {
    publicFunClass
  } from '@/components/js/PublicFunClass.js'
  import BigScreenOnePop from '@/components/bigScreen/BigScreenOnePop.vue';
  import trafficAnalysisVue from '@/components/bigScreen/trafficAnalysis.vue';
  import callTrendVue from '@/components/bigScreen/callTrend.vue';
  import agentStatusVue from '@/components/bigScreen/agentStatus.vue';
  import skillGroupVue from '@/components/bigScreen/skillGroup.vue';
  import satisfactionVue from '@/components/bigScreen/satisfaction.vue';
  export default {
    name: "CallAllView",
    mixins: [publicFunClass],
    components: {
      BigScreenOnePop,
      trafficAnalysisVue, //话务分析
      callTrendVue, //通话趋势
      agentStatusVue, //座席状态
      skillGroupVue, //技能组统计
      satisfactionVue, //满意度评价,
    },
    props:{
        pageCode:String
      },
    data() {
      return {
        title: '通话总览', //大屏标题
        logo: '', //大屏logo
        bgImg: require('../../assets/image/bg.jpg'), //大屏背景
        fullscreen: false,
        showBigScreenOne: false,
        screenHeight: {
          height: '',
        },
        viewLayout: {
          itemTop: [{
            span: '15',
            pull: '',
            push: '',
            activeClass: 'panel1',
            echartType: 'callTrend'
          }, {
            span: '9',
            pull: '',
            push: '',
            activeClass: 'panel2',
            echartType: 'trafficAnalysis'
          }],
          itemBottom: [{
              span: '7',
              pull: '',
              push: '',
              activeClass: 'panel3',
              echartType: 'agentStatus'
            },
            {
              span: '10',
              pull: '',
              push: '',
              activeClass: 'panel4',
              echartType: 'skillGroup'
            },
            {
              span: '7',
              pull: '',
              push: '',
              activeClass: 'panel5',
              echartType: 'satisfaction'
            },
          ]
        },
        // 设置顺序(有默认顺序,基于默认顺序)
        toplefPush: "8",
        topRightPull: '16',
        bottomLeftPush: '16',
        bottomMiddlePull: '8',
        bottomRightPull: '8',

        // 对话框组件
        showScrenModal: false,
        // 设置icon
        setButton: require('../../assets/image/screen_setting.png'),
        timeFlag:null,
        dt: null,
        year:null,
        month:null,
        day:null,
        hour:null,
        minute:null,
        seconds:null,
      };
    },
    methods: {
      closeBigScreenOne: function (flag) {
        this.showBigScreenOne = false;
        if (flag) {
          this.init();
        }
      },

      // 设置大屏
      setScreen(id) {
        this.showScrenModal = true;
        this.showBigScreenOne = true;
      },
      // 处理实时时间
      setTime() {
  
        let that = this;
          that.dt = new Date();
          that.year = that.dt.getFullYear();
          that.month = that.dt.getMonth() + 1;
          that.day = that.dt.getDate();
          that.hour = that.dt.getHours(); //获取时
          that.minute = that.dt.getMinutes(); //获取分
          that.seconds = that.dt.getSeconds(); //获取秒
          
          document.querySelector(".showTime").innerHTML =
             that.year + "-" +          //年
            (that.month < 10 ? ("0" + that.month) : that.month) + "-" +  //月
            (that.day < 10 ? ("0" + that.day) : that.day) +       //日
            "&nbsp;&nbsp;&nbsp" +
            (that.hour < 10 ? ("0" + that.hour) : that.hour) + ":" +    //时
            
            (that.minute < 10 ? ("0" + that.minute) : that.minute) + ":" + //分
            
            (that.seconds < 10 ? ("0" + that.seconds) : that.seconds);  //秒
      },

      init() {
        let that = this;
        this.setTime(); // 实时时间
        that.timeFlag = setInterval(that.setTime, 1000); //开始运行
        
        // 获取图表位置
        let param = {
          journalType: null,
          menuId: null,
          type: "callView"
        };
        this.$http.post("bigScreen/toBigScreenIndex.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.viewLayout = JSON.parse(res.data.obj.configDesign.value);
          var configPic = JSON.parse(res.data.obj.configPic);

          if ("" != configPic.callView) {
            that.title = configPic.callView;
          }
          if ("" != configPic.logo) {
            that.logo = that.baseImgURL + configPic.logo;
          }else{
            that.logo = require('../../assets/image/logo.png');
          }
          if ("" != configPic.bgImg) {
            that.bgImg = that.baseImgURL + configPic.bgImg;

          }
        });
      },


      // 全屏事件

      handleFullScreen() {

        let element = document.getElementById("bigScreen"); //放大的元素，如果整个系统放大，直接赋值 document.documentElement

        if (this.fullscreen) {

          if (document.exitFullscreen) {

            document.exitFullscreen();

          } else if (document.webkitCancelFullScreen) {

            document.webkitCancelFullScreen();

          } else if (document.mozCancelFullScreen) {

            document.mozCancelFullScreen();

          } else if (document.msExitFullscreen) {

            document.msExitFullscreen();

          }

        } else {

          if (element.requestFullscreen) {

            element.requestFullscreen();

          } else if (element.webkitRequestFullScreen) {

            element.webkitRequestFullScreen();

          } else if (element.mozRequestFullScreen) {

            element.mozRequestFullScreen();

          } else if (element.msRequestFullscreen) {

            // IE11

            element.msRequestFullscreen();

          }

        }

        this.fullscreen = !this.fullscreen;

      },
      btnFull() {

        this.fullscreen = false;

        this.handleFullScreen();
        //this.isFullFlag=true;
      },
      resizeFun(){
        var firstOnResizeFire = true; //谷歌浏览器onresize事件会执行2次，这里加个标志位控制
        let that = this;
        if (firstOnResizeFire) {

          var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen;
          if (isFull === undefined) {
            isFull = false;
          }
          if (isFull) {
            that.fullscreen = true;
            that.$forceUpdate();
          } else {
            that.fullscreen = false;
            that.$forceUpdate();
          }

          setTimeout(function () {
            firstOnResizeFire = true;
          }, 500);
          return isFull;
        }
      },

    },
    created() {
      this.screenHeight.height = this.mountHeight(100);
      
    },
    mounted() {

      this.init();
      
      window.addEventListener("resize", this.resizeFun);
    },
    beforeDestroy() {
      if(this.timeFlag){
        clearInterval(this.timeFlag);
      }
      window.removeEventListener("resize", this.resizeFun);
      this.resizeFun = null;
      this.init = null;
      this.handleFullScreen = null;
      this.btnFull = null;
      this.setTime = null;
      this.setScreen = null;
      this.closeBigScreenOne = null;
    },
    destroyed() {
      
    },
    

  };
</script>

<style scoped lang="less">
  @import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/CallAllView.vue